import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Layout, Result, Skeleton, Typography } from "antd";
import { DownloadOutlined, LeftCircleOutlined } from "@ant-design/icons";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import { saveAs } from "file-saver";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

import { getAvisoPrivacidad } from "../../../redux/avisoprivacidad/descargaPrivacidad";
import { base64toBlob, ERROR_ARCHIVO } from "../../../utils";
import { linksRouter } from "../../../config/RouterLink";

const { Title } = Typography;

export const AvisoPrivacidadPage = () => {
  const dispatch = useDispatch();
  const {
    location: { pathname },
  } = useHistory();
  const base64 = "data:application/pdf;base64";

  const [aviso, setAviso] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMounted = useRef(true);

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  //useEffect que valida si el componente está montado en la App.
  useEffect(() => {
    return () => {
      isMounted.current = false; //Desmontar el componente
    };
  }, []);

  useEffect(() => {
    window.scroll({
      top: 100,
      behavior: "smooth",
    });
  }, [pageNumber]);

  useEffect(() => {
    if (isMounted.current) {
      const idTipo = pathname === linksRouter.avisoPrivacidadINE ? 1 : 2;
      setLoading(true);
      dispatch(getAvisoPrivacidad(idTipo))
        .then(({ data }) => {
          setAviso(data);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadAviso = (item) => {
    const { nombreArchivo, archivoBase64 } = item;
    saveAs(new Blob([base64toBlob(archivoBase64)]), `${nombreArchivo}.pdf`);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  return (
    <Layout className="site-layout">
      <div className="site-layout-content">
        <div style={{ marginBottom: 20, marginTop: 20 }}>
          <Link to={linksRouter.raiz} className="link">
            <LeftCircleOutlined /> Regresar
          </Link>
        </div>
        <div>
          <Title level={2}>Avisos de Privacidad</Title>
        </div>

        <div>
          {loading ? (
            <Skeleton active paragraph={{ rows: 15 }} title={false} />
          ) : (
            <>
              {aviso.length > 0 ? (
                <>
                  {aviso.map((item) => (
                    <div
                      className="link descarga-ayuda"
                      onClick={() => {
                        downloadAviso(item);
                      }}
                      key={item.orden}
                    >
                      <DownloadOutlined /> Descargar {item.nombreArchivo}
                    </div>
                  ))}

                  <div>
                    <Document
                      file={`${base64},${aviso[1].archivoBase64}`}
                      options={{ workerSrc: "/pdf.worker.js" }}
                      onLoadSuccess={onDocumentLoadSuccess}
                      loading={<div>Espere un momento..</div>}
                    >
                      <Page pageNumber={pageNumber} />
                    </Document>
                    <center>
                      <p>
                        Página {pageNumber || (numPages ? 1 : "--")} de{" "}
                        {numPages || "--"}
                      </p>

                      <Button
                        style={{ margin: "0 8px" }}
                        type="primary"
                        disabled={pageNumber <= 1}
                        onClick={() => {
                          changePage(-1);
                        }}
                      >
                        <LeftOutlined /> Anterior
                      </Button>

                      <Button
                        type="primary"
                        disabled={pageNumber >= numPages}
                        onClick={() => {
                          changePage(+1);
                        }}
                      >
                        Siguiente <RightOutlined />
                      </Button>
                    </center>
                  </div>
                </>
              ) : (
                <Result
                  status="warning"
                  title={ERROR_ARCHIVO}
                  extra={
                    <Link to={linksRouter.raiz}>
                      <Button type="primary">Inicio</Button>
                    </Link>
                  }
                />
              )}
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};
